export const theme = {
  textRegular: '#444444',
  textDarker: '#444444',
  backgroundLight: '#f8f6f5',
  backgroundDark: '#2c211b',
  black: '#000000',
  red: '#f55',
  coral: '#f66951',
  redBright: '#FF5651',
  redLight: '#F76950',
  blueLightest: '#FAFFFF',
  blue: '#52C7EB',
  blueLight: '#dcf1f3',
  blueDark: '#2178af',
  blueMedium: '#a8d4d3',
  green: '#1D9182',
  greenForest: '#37632F',
  teal: '#87D4B6',
  forest: '#52B389',
  bluish: '#4AAFB3',
  yellow: '#ffc439',
  yellowLight: '#FEFBE8',
  cream: '#FFFEF9',
  gold: '#F3CB4E',
  golden: '#ce812d',
  gray: '#b6aca6',
  grayDark: '#444444',
  grayDarker: '#505050',
  grayLight: '#9099A0',
  onboardGray: '#2D2D2D',
  compareGray: '#F9F8F2',
  whiteLight: '#F8F9F9',
  brown: '#6D481C',
  orange: '#fdc36d',
  pastelBlue: '#edf9ff',
  lilac: '#f1f0fb',
  violet: '#80A2F8',
  holidayRed: '#CC3B48',
  pink: '#FCDFDF',
  mediumPink: '#ED9D9C',
  darkPink: '#954341',
  lavender: '#D6D5E7',
  emerald: '#043A3C',
  lime: '#B2E3AA',
  glow: '#25C587',
  sage: '#B7CBBF',
  space: '#2B2B2B',
  white: '#FFFFFF',
  primeBlue: '#0578FF',
  mint: '#A7DFC5',
  sky: '#DCF1F2',
  compRowAlt: '#f5f5f4',
  compDividers: '#093642',
  cloud: '#FAF7F3',
  Builder_Cloud: '#FAF7F3',
  Builder_Cream: '#FFFEF9',
  Light_Sprout: '#DBEFC2',
  Sprout: '#B6E085',
  Light_Grapefruit: '#FDD4C9',
  Grapefruit: '#FBA994',
  Landing_Sky: '#DCF1F2',
  Light_Sky: '#C1EBEE',
  Builder_Sky: '#82D7DD',
  Light_Gemstone: '#CCFOE7',
  Dark_Gemstone: '#007366',
  Light_Lavender: '#EEE2F7',
  Deep_Lavender: '#915EA1',
}

export const breakpoints = {
  s: 576,
  m: 768,
  l: 992,
  xl: 1200,
}
